import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import {
  Typography,
  TypographyComponentEnum,
  TypographyVariant,
} from '@unisporkal/alliance-ui';
import ExclamationIcon from '../../icons/Exclamation.svg?icon';
import styles from './WarningBox.module.scss';

type WarningBoxProps = {
  heading?: string;
};

const WarningBox = ({ heading }: WarningBoxProps = {}) => {
  const t = useTranslations();

  return (
    <div className={styles.warningBoxContainer}>
      <div
        className={styles.warningBox}
        data-testid="warning-box"
      >
        <div className={styles.headingContainer}>
          {!heading && <ExclamationIcon className={styles.icon} />}
          <Typography
            component={TypographyComponentEnum.P}
            data-testid="warning-header"
            className={styles.headingText}
            variant={TypographyVariant.body.small}
          >
            {heading ?? t('something_went_wrong')}
          </Typography>
        </div>
        {!heading && (
          <div className={styles.textContainer}>
            <Typography
              component={TypographyComponentEnum.P}
              data-testid="warning-text"
              className={styles.warningText}
              variant={TypographyVariant.body.small}
            >
              {t('unable_to_process_your_request_try_later')}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

export default WarningBox;
